module.exports = __webpack_public_path__ + "img/VL_11_03.bdcb7a3e.png";